import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import '@/styles/main.scss'

import {i18n} from "../i18n";
import { store } from '../store';

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#e5007f',
        secondary: '#b0bec5',
        accent: '#eb0185',
        error: '#b71c1c',
        info: '#1B1464',
        background: '#fdf7fb',
        menuText: '#333',
        menuBackground: '#fff',
        textOnPrimary: '#fff',
      },
      dark: {
        primary: '#47ccf9',
        secondary: '#b0bec5',
        accent: '#47ccf9',
        error: '#b71c1c',
        info: '#1B1464',
        background: '#1E1E1E',
        menuText: '#fff',
        menuBackground: '#333',
        textOnPrimary: '#000',
      },
    },
  },
});
